import React, { useEffect, useRef } from 'react';
import './ShopifyAccountingSystem.css';
import NavBar3 from '../../components/NavBar3/NavBar3';
import Skriptlogo from '../../assets/logos/logo.png';
import shopifylogo from '../../assets/icons/shopify.svg';
import HeaderTrackingImage from '../../assets/images/dashboard.png';
import tabletImage from '../../assets/images/galaxytala1.png';
import macStudio from '../../assets/images/MacStudio.png';
import receiptImage from '../../assets/images/Samsung TV.png';
import statementImg from '../../assets/images/statementofaccount.png';
import { motion, useAnimation, useInView } from 'framer-motion';
import Particles from 'react-tsparticles';
import { loadSlim } from 'tsparticles-slim';

const ShopifyAccountingSystem = () => {
  const sphereRef = useRef(null);
  const scrollPos = useRef(0);
  const spherePos = useRef(-50);
  const controls = useAnimation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });

  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView, controls]);

  useEffect(() => {
    const sphere = sphereRef.current;
    sphere.classList.add('animate-in');

    const handleScroll = () => {
      const currentScroll = window.scrollY;
      const scrollDirection = currentScroll > scrollPos.current ? 'down' : 'up';
      scrollPos.current = currentScroll;

      if (scrollDirection === 'down') {
        spherePos.current = Math.min(0, spherePos.current + 0.5);
      } else {
        spherePos.current = Math.max(-100, spherePos.current - 0.5);
      }

      sphere.style.transform = `translateY(${spherePos.current}%)`;
    };

    let ticking = false;
    const optimizedScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', optimizedScroll);
    return () => window.removeEventListener('scroll', optimizedScroll);
  }, []);

  const particlesInit = async (engine) => {
    await loadSlim(engine);
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    }
  };
  
  return (
    <div className="shopify-accounting-system-page">
      <div className="background-sphere" id="background-sphere" ref={sphereRef}></div>
      <Particles
        id="tsparticles"
        init={particlesInit}
        options={{
          background: { color: { value: "transparent" } },
          fpsLimit: 120,
          interactivity: {
            events: {
              onClick: { enable: true, mode: "push" },
              onHover: { enable: true, mode: "repulse" }
            },
            modes: {
              push: { quantity: 4 },
              repulse: { distance: 100, duration: 0.4 }
            }
          },
          particles: {
            color: { value: ["#FF9000", "#FFD700", "#FFFFFF"] },
            links: {
              color: "#FF9000",
              distance: 150,
              enable: true,
              opacity: 0.3,
              width: 1
            },
            move: {
              direction: "none",
              enable: true,
              outModes: { default: "bounce" },
              random: false,
              speed: 1,
              straight: false
            },
            number: { density: { enable: true }, value: 80 },
            opacity: { value: { min: 0.1, max: 0.5 } },
            shape: { type: "circle" },
            size: { value: { min: 1, max: 3 } }
          },
          detectRetina: true
        }}
      />
      
      <NavBar3 />
      
      <motion.div 
        className="tracking-hero"
        initial="hidden"
        animate="visible"
        variants={containerVariants}
      >
        {/* <motion.div className='skript-logo' variants={itemVariants}>
          <img src={Skriptlogo} alt="logo"/>
        </motion.div>
        
        <motion.div className="shopify-finance" variants={itemVariants}>
          <div className='shopify-logo'>
            <img src={shopifylogo} alt="shopify logo"/>
          </div>
          <h4>Shopify Finance</h4>
        </motion.div> */}
        
        <motion.h1 variants={itemVariants}>
          Unlock Growth with a Shopify Accounting System Built for Success
        </motion.h1>
        
        <motion.p className="tracking-subtitle" variants={itemVariants}>
          Built to simplify accounting, save time, and scale with your business
        </motion.p>
        
        {/* <motion.div className="platform-buttons" variants={itemVariants}>
          <button className="platform-btn mac">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.773 22.773" width="22" height="22" fill="#ffffff">
              <path d="M15.769,0c0.053,0,0.106,0,0.162,0c0.13,1.606-0.483,2.806-1.228,3.675c-0.731,0.863-1.732,1.7-3.351,1.573 c-0.108-1.583,0.506-2.694,1.25-3.561C13.292,0.879,14.557,0.16,15.769,0z" />
              <path d="M20.67,16.716c0,0.016,0,0.03,0,0.045c-0.455,1.378-1.104,2.559-1.896,3.655c-0.723,0.995-1.609,2.334-3.191,2.334 c-1.367,0-2.275-0.879-3.676-0.903c-1.482-0.024-2.297,0.735-3.652,0.926c-0.155,0-0.31,0-0.462,0 c-0.995-0.144-1.798-0.932-2.383-1.642c-1.725-2.098-3.058-4.808-3.306-8.276c0-0.34,0-0.679,0-1.019 c0.105-2.482,1.311-4.5,2.914-5.478c0.846-0.52,2.009-0.963,3.304-0.765c0.555,0.086,1.122,0.276,1.619,0.464 c0.471,0.181,1.06,0.502,1.618,0.485c0.378-0.011,0.754-0.208,1.135-0.347c1.116-0.403,2.21-0.865,3.652-0.648 c1.733,0.262,2.963,1.032,3.723,2.22c-1.466,0.933-2.625,2.339-2.427,4.74C17.818,14.688,19.086,15.964,20.67,16.716z" />
            </svg>
            macOS
          </button>

          <button className="platform-btn windows">
            <svg width="24" height="24" viewBox="0 0 512 512" fill="#000000" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 93.7L226.8 61v194.3H0V93.7zM0 418.3l226.8 32.6V275.2H0v143.1zM249.2 447.3l262.8 37.9V275.2H249.2v172.1zM249.2 64.7v190.6h262.8V26.8L249.2 64.7z" />
            </svg>
            Windows
          </button>
        </motion.div> */}
      </motion.div>
      
      <motion.div 
        className='header-tracking-image'
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <img src={HeaderTrackingImage} alt="header tracking"/>
      </motion.div>
      
      <motion.section 
        className="customer-overview-section"
        initial="hidden"
        whileInView="visible"
        variants={containerVariants}
        viewport={{ once: true }}
      >
        <motion.div className="overview-image" variants={itemVariants}>
          <img src={tabletImage} alt="Customer Summary Dashboard" />
        </motion.div>
        <motion.div className="overview-text" variants={itemVariants}>
          <h2 className="section-title">Customer & Financial Overview</h2>
          <p className="section-description">
            View detailed customer profiles with VAT info and purchase history.
            Monitor real-time account summaries, and export statements in PDF.
          </p>
          <div className="feature-tags">
            <motion.div className="tag-card" whileHover={{ scale: 1.05 }}>
              <span className="emoji">📋</span>
              Customer profile with VAT, email, and phone
            </motion.div>
            <motion.div className="tag-card" whileHover={{ scale: 1.05 }}>
              <span className="emoji">📊</span>
              Account summary with circular spend graph
            </motion.div>
            <motion.div className="tag-card" whileHover={{ scale: 1.05 }}>
              <span className="emoji">🧾</span>
              Exportable statement of account (PDF)
            </motion.div>
          </div>
        </motion.div>
      </motion.section>
    
     <motion.section 
  className="section section-order"
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true, margin: "-100px" }}
>
  <motion.div 
    className="section-content"
    initial={{ opacity: 0, x: -20 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.6, delay: 0.2 }}
    viewport={{ once: true }}
  >
    <h2 className="section-title">Order Management & Invoicing</h2>
    <motion.p 
      className="section-description"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      viewport={{ once: true }}
    >
      Gain full visibility on customer orders and invoice breakdowns. Automatically fetch Shopify order IDs, dates, and itemized product details including vendor, quantity, and pricing.
    </motion.p>
    <motion.div 
      className="feature-tags"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ staggerChildren: 0.1, delayChildren: 0.3 }}
      viewport={{ once: true }}
    >
      <motion.div 
        className="tag-card"
        whileHover={{ scale: 1.05 }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        viewport={{ once: true }}
      >
        <span className="emoji">🧾</span>
        Auto-generated invoices from orders
      </motion.div>
      <motion.div 
        className="tag-card"
        whileHover={{ scale: 1.05 }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <span className="emoji">📦</span>
        Order detail view with item breakdown
      </motion.div>
      <motion.div 
        className="tag-card"
        whileHover={{ scale: 1.05 }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <span className="emoji">🧮</span>
        Subtotals, discounts, tax, and total
      </motion.div>
    </motion.div>
  </motion.div>
  <motion.div 
    className="section-image"
    initial={{ opacity: 0, x: 20 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.6, delay: 0.3 }}
    viewport={{ once: true }}
  >
    <img src={macStudio} alt="Order Management & Invoicing" />
  </motion.div>
</motion.section>

<motion.section 
  className="section section-order"
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true, margin: "-100px" }}
>
  <motion.div 
    className="section-image"
    initial={{ opacity: 0, x: -20 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.6, delay: 0.3 }}
    viewport={{ once: true }}
  >
    <img src={receiptImage} alt="Receipts & Payment Tracking" />
  </motion.div>
  <motion.div 
    className="section-content"
    initial={{ opacity: 0, x: 20 }}
    whileInView={{ opacity: 1, x: 0 }}
    transition={{ duration: 0.6, delay: 0.2 }}
    viewport={{ once: true }}
  >
    <h2 className="section-title">Receipts & Payment Tracking</h2>
    <motion.p 
      className="section-description"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.4 }}
      viewport={{ once: true }}
    >
      Create, archive, and export receipts for every customer transaction. Easily switch between cash and check modes, and keep payment records organized with real-time filters and PDF output.
    </motion.p>
    <motion.div 
      className="feature-tags"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ staggerChildren: 0.1, delayChildren: 0.3 }}
      viewport={{ once: true }}
    >
      <motion.div 
        className="tag-card"
        whileHover={{ scale: 1.05 }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        viewport={{ once: true }}
      >
        <span className="emoji">💰</span>
        Cash & Check Payment Modes
      </motion.div>
      <motion.div 
        className="tag-card"
        whileHover={{ scale: 1.05 }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <span className="emoji">📁</span>
        Receipt Archiving by Status
      </motion.div>
      <motion.div 
        className="tag-card"
        whileHover={{ scale: 1.05 }}
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <span className="emoji">🧾</span>
        PDF Receipt Export
      </motion.div>
    </motion.div>
  </motion.div>
</motion.section>

<motion.section 
  className="statement-center-section"
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true }}
>
  <motion.h2 
    className="statement-title"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    viewport={{ once: true }}
  >
    Statement of Account
  </motion.h2>
  <motion.p 
    className="statement-subtitle"
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay: 0.2 }}
    viewport={{ once: true }}
  >
    Generate and export a full transaction history with running balance. Perfect for
    reconciling customer accounts and maintaining accurate records.
  </motion.p>
  <motion.div 
    className="statement-image-container"
    initial={{ opacity: 0, scale: 0.95 }}
    whileInView={{ opacity: 1, scale: 1 }}
    transition={{ duration: 0.8, delay: 0.3 }}
    viewport={{ once: true }}
  >
    <img src={statementImg} alt="Statement of Account Preview" />
  </motion.div>
</motion.section>

<motion.section 
  className="shopify-tracking-section"
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true }}
>
  <div className="tracking-container">
    <motion.div 
      className="tracking-header"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.6, delay: 0.2 }}
      viewport={{ once: true }}
    >
      <h2 className="section-title">Real-Time Shopify Order Tracking</h2>
      <p className="section-subtitle">Monitor every transaction with our intuitive dashboard</p>
    </motion.div>

    <div className="tracking-features">
      <motion.div 
        className="tracking-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <div className="card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M21 11V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h6m4-14h6m-6 4h6m-6 4h6"/>
          </svg>
        </div>
        <h3>Order Sync</h3>
        <p>Automatically imports all Shopify orders in real-time with complete product details</p>
      </motion.div>

      <motion.div 
        className="tracking-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.1 }}
        viewport={{ once: true }}
      >
        <div className="card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
          </svg>
        </div>
        <h3>Revenue Analytics</h3>
        <p>Track sales trends, customer spending patterns, and revenue forecasts</p>
      </motion.div>

      <motion.div 
        className="tracking-card"
        whileHover={{ y: -10 }}
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
        viewport={{ once: true }}
      >
        <div className="card-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M12 2v4m0 12v4M4.93 4.93l2.83 2.83m8.48 8.48l2.83 2.83M2 12h4m12 0h4M4.93 19.07l2.83-2.83m8.48-8.48l2.83-2.83"/>
          </svg>
        </div>
        <h3>Inventory Alerts</h3>
        <p>Get notified when stock levels are low or products need restocking</p>
      </motion.div>
    </div>

    <motion.div 
      className="demo-container"
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.8, delay: 0.3 }}
      viewport={{ once: true }}
    >
        <div className="demo-mockup">
          <div className="demo-header">
            <div className="demo-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="demo-search">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
            </div>
          </div>
          <div className="demo-content">
            <div className="demo-row active">
              <div className="demo-badge">New</div>
              <span>Order #1001 - $249.99</span>
              <span>Processing</span>
            </div>
            <div className="demo-row">
              <span>Order #1000 - $149.99</span>
              <span>Fulfilled</span>
            </div>
            <div className="demo-row">
              <span>Order #999 - $79.99</span>
              <span>Completed</span>
            </div>
            <div className="demo-row">
              <span>Order #998 - $199.99</span>
              <span>Completed</span>
            </div>
          </div>
        </div>
    </motion.div>
  </div>
</motion.section>

<motion.section 
  className="testimonial-section"
  initial={{ opacity: 0 }}
  whileInView={{ opacity: 1 }}
  transition={{ duration: 0.8 }}
  viewport={{ once: true }}
>
  {/* <motion.p 
    className="quote"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    viewport={{ once: true }}
  >
    "This system completely transformed the way we track orders, generate receipts, and manage financial reports — it's an essential tool for any growing Shopify store."
  </motion.p> */}
  <motion.div 
    className="author"
    initial={{ opacity: 0 }}
    whileInView={{ opacity: 1 }}
    transition={{ duration: 0.6, delay: 0.3 }}
    viewport={{ once: true }}
  >
    <strong>This Software Is The Property Of Skript LLC</strong>
    {/* <span>Founder & CEO</span> */}
  </motion.div>
  <motion.div 
    className="progress-bar"
    initial={{ width: 0 }}
    whileInView={{ width: "100%" }}
    transition={{ duration: 1.5, delay: 0.4 }}
    viewport={{ once: true }}
  >
    <span className="active" />
  </motion.div>
</motion.section>
    </div>
  );
};

export default ShopifyAccountingSystem;
